import { Badge } from "@/components/ui/badge";
import { WHOLESALE_STATUS_LABELS, type WholesaleStatus } from "@/lib/wholesale";

type BadgeVariant = "default" | "secondary" | "destructive" | "outline";

const STATUS_VARIANT: Record<WholesaleStatus, BadgeVariant> = {
  draft: "outline",
  submitted: "secondary",
  confirmed: "default",
  packed: "secondary",
  shipped: "secondary",
  completed: "outline",
  cancelled: "destructive",
};

export function WholesaleStatusBadge({ status }: { status?: string }) {
  const key = (status ?? "") as WholesaleStatus;
  const label = WHOLESALE_STATUS_LABELS[key] ?? status ?? "—";
  return <Badge variant={STATUS_VARIANT[key] ?? "outline"}>{label}</Badge>;
}

const STOCK_LABEL: Record<string, { label: string; variant: BadgeVariant }> = {
  pending: { label: "Upis zalihe u toku", variant: "secondary" },
  ok: { label: "Zaliha upisana", variant: "outline" },
  failed: { label: "Zaliha nije upisana", variant: "destructive" },
};

export function StockBadge({ state }: { state?: string }) {
  const cfg = STOCK_LABEL[state ?? ""];
  if (!cfg) return null;
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}
